import React from "react";
import { Button } from "@mui/material";
import { formatCurrency } from "../helpers/utils";

const CardHeaderInfo = () => {
    return (
        <div className="d-flex flex-wrap justify-content-between">
            <div className="w-100 w-lg-auto">
                <div className="d-flex flex-wrap">
                    <div className="ps-0 ps-sm-5 mb-4 mb-md-3 w-100 w-sm-auto">
                        <div className="font-size-12 font-weight-500 text-grey">МАСТЕР КАРТЫН ҮЛДЭГДЭЛ</div>
                        <div className="font-size-20 font-weight-bold text-secondary">{formatCurrency(2000000)}</div>
                    </div>
                    <div className="ps-0 ps-sm-5 mb-4 mb-md-3 w-50 w-sm-auto">
                        <div className="font-size-12 font-weight-500 text-grey">КАРТЫН ДУГААР</div>
                        <div className="font-size-16 font-weight-500">5098 0998 7584</div>
                    </div>
                    <div className="pe-2 pe-sm-0 mb-4 mb-md-3 w-50 w-sm-auto">
                        <div className="font-size-12 font-weight-500 text-grey">ЭЗЭМШИГЧ</div>
                        <div className="font-size-16 font-weight-500">Билгүүн Мөнхбат</div>
                    </div>
                </div>
            </div>
            <div className="w-100 w-lg-auto">
                <div className="d-flex flex-wrap flex-column-reverse flex-sm-row justify-content-start justify-content-xl-end">
                    <div className="w-100 w-sm-auto pointer font-weight-500 flex-center mb-3 me-0 me-sm-3">
                        <img alt="question" src="/images/question.svg" className="ms-2" height={16} /> Цэнэглэх заавар
                    </div>
                    <Button
                        className="w-100 w-sm-auto bg-primary btn-bordered me-0 me-sm-4 mb-3"
                        variant="contained"
                        disableElevation
                        startIcon={<i className='bx bx-plus text-white font-size-20'></i>}
                    >
                        Толгой карт цэнэглэх
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CardHeaderInfo;